import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const userApprovalsSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="approvals-header"]',
    content:
      'Esta página gerencia os usuários que solicitaram acesso ao sistema e aguardam aprovação de um administrador.',
  },
  {
    selector: '[data-tour="approvals-table"]',
    content:
      'A tabela mostra nome, e-mail, cargo sugerido e data de cadastro de cada usuário pendente.',
  },
  {
    selector: '[data-tour="approvals-approve-btn"]',
    content:
      'Clique em Aprovar para ativar o usuário. Você poderá configurar o cargo oficial e o nível de permissão antes de confirmar.',
  },
];

export const settingsSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="settings-card"]',
    content:
      'As configurações do sistema controlam funcionalidades globais como aprovação por comitê no intake e o módulo de auditoria.',
  },
  {
    selector: '[data-tour="settings-intake-switch"]',
    content:
      'Ative esta opção para exigir aprovação de comitê antes que uma ficha de triagem avance para o Bridge 1.',
  },
  {
    selector: '[data-tour="settings-audit-switch"]',
    content:
      'Ative ou desative o módulo de auditoria. Quando ativo, todas as ações críticas dos usuários são registradas com data, hora e responsável.',
  },
  {
    selector: '[data-tour="settings-save-btn"]',
    content: 'Clique em Salvar para aplicar as alterações de configuração.',
  },
];

export const alertsSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="alerts-header"]',
    content:
      'Os alertas automáticos notificam os usuários sobre eventos importantes: milestones atrasados, projetos sem atualização e orçamentos excedidos.',
  },
  {
    selector: '[data-tour="alerts-table"]',
    content:
      'Configure aqui o tipo, frequência e destinatários de cada alerta. Os alertas são enviados por e-mail e aparecem no sino de notificações.',
  },
];

export const plansSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="plans-header"]',
    content:
      'Os planos definem quais funcionalidades estão disponíveis para cada tenant: Projetos, Tarefas, Riscos, Portfólio, Relatórios, OKRs e muito mais.',
  },
  {
    selector: '[data-tour="plans-table"]',
    content:
      'Compare os planos disponíveis e assign para tenants. Cada plano habilita um conjunto de features no sistema.',
  },
];

export const auditSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="audit-header"]',
    content:
      'O log de auditoria registra todas as ações críticas realizadas no sistema: criação, edição, exclusão e aprovações. Útil para conformidade e rastreabilidade.',
  },
  {
    selector: '[data-tour="audit-table"]',
    content:
      'Filtre por usuário, ação ou período para localizar eventos específicos. Os registros podem ser exportados para CSV.',
  },
];
